<template>
  <v-container fluid class="px-0 py-0">
    <CorePickPlaceSheetTable
        title=""
        dto-list-query="PickPlaceSheetListQueryDTO"
        :store-name="storeTableName"
        :height="height - 260"
        :detail-store-name="storeDetailName"
        :hide-default-footer="true"
        :hide-default-header="true"
        :show-select="true"
        :main-validator="false"
        :row-background="rowBackground"
        @embedded_action="embeddedAction($event)"
    ></CorePickPlaceSheetTable>
    <v-dialog
        v-model="dialogImportPickPlaceTable"
    >
      <CoreImportPickPlaceTable
          @cancel="onImportPickPlaceClose()"
          @import="importPickPlaceTable($event)"
      >
      </CoreImportPickPlaceTable>
    </v-dialog>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CoreBomDetail from "@/components/CoreComponent/Bom/CoreBomDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";
import {useDetailStore} from "@/components/Common/CommonDetail";
import CorePickPlaceSheetTable from "@/components/CoreComponent/PickPlaceSheet/CorePickPlaceSheetTable";
import CoreImportPickPlaceTable from "@/components/CoreComponent/PickPlace/CoreImportPickPlaceTable";

export default {
  name: "CoreProductOrderPickPlaceTable",

  props: {
    height: {default: null},
    product_order_uid: {default: null}
  },

  components: {
    CommonTable,
    CoreBomDetail,
    BaseFieldCheck,
    CorePickPlaceSheetTable,
    CoreImportPickPlaceTable,
  },

  watch: {
    product_order_uid: {
      handler(newValue, oldValue) {
        // console.log('watch BomDetail uidItem', newValue, oldValue)
        this.filterTable()
        this.storeDetail.parentUid = this.product_order_uid
        this.storeTable.uidItem = this.product_order_uid
      },
      deep: true
    },
  },

  methods: {
    embeddedAction(event) {
      console.log('embeddedAction', event)
      if (event.actionName === 'embedded_import_pick_place') {
        this.dialogImportPickPlaceTable = true
      }
    },
    onImportPickPlaceClose() {
      // console.log('onImportClose', event)
      this.dialogImportPickPlaceTable = false
    },
    importPickPlaceTable(event) {
      // console.log('importPickPlaceTable', event)
      let data = {
        selected_items: event.selectedItems,
        first_side_name: event.firstSideName,
        second_side_name: event.secondSideName,
        unit: event.unit,
      }
      this.storeTable.onAction({actionName: 'import_sheet', actionUid: null, data: data})
      this.dialogImportPickPlaceTable = false
    },
    rowBackground(item) {
      if (item.import_error_status === 'ERROR')
        return 'red lighten-4'
      if (item.import_error_status === 'WARNING')
        return 'orange lighten-4'
      if (item.import_error_status === 'SUCCESS')
        return 'green lighten-4'
    },
    filterTable() {
      this.storeTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'product_order__uid', value: this.product_order_uid, enable: true},
        ],
        enable: true,
      }
    },
  },


  mounted() {
    this.storeDetail = useDetailStore(this.storeDetailName)()
    this.storeAggregate = useAggregateStore()
    this.storeTable = useTableStore(this.storeTableName)()
    this.storeTable.uidItem = this.product_order_uid
    this.storeTable.options.itemsPerPage = -1
    this.storeTable.options.sortBy = ['designator']
    this.storeTable.options.sortDesc = [true]
    this.storeTable.footerProps = {'items-per-page-options': [5, 20, 50, 100, 200, -1]}
    this.filterTable()
    this.storeDetail.parentUid = this.product_order_uid
    this.storeTable.uidItem = this.product_order_uid
  },

  data() {
    return {
      dialogImportPickPlaceTable: false,
      storeDetail: null,
      storeDetailName: uuidv4(),
      storeAggregate: null,
      storeTable: null,
      storeTableName: uuidv4(),
    }
  },
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>